import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import {useTranslation} from 'react-i18next';

import {toast} from 'react-toastify';
import {useFormik} from 'formik';
import * as Yup from 'yup';
import * as RestService from '../../services/eisRest';
import DatePicker, { registerLocale, setDefaultLocale } from "react-datepicker";
import sk from 'date-fns/locale/sk';
import * as moment from 'moment';
import NumberFormat from 'react-number-format';

import "react-datepicker/dist/react-datepicker.css";
registerLocale('sk', sk)




const WorkingTimeTab = (props) => {

   // const [selectedRecord, setSelectedRecord] =  useState(null);  
    const [start, setStart] =  useState(null);  
    const [t] = useTranslation();           
    const [user, setUser] = useState();
 
 
  
    
    const hideModal = () => {
      props.parentCallback();
    };
    
  

    const apiOrder = (call) => {
        switch(call){       
          case "getUser":
            RestService.callAnyApi('user/getUser?id='+props.selectedRecord, null)
            .then((data) => {
                 setUser(data);   
                 //console.log();
                 setStart(moment(data.workingTime.start, "HH:mm:ss").valueOf());
            })
            .catch((error) => {    
              toast.error(error);
            });
          break;          
        }

    }
   

 
    useEffect(() => {      
     // setSelectedRecord(props.selectedRecord);     
      apiOrder("getUser");

    }, [props.selectedRecord])

  
  
    const handleChange = (e,elementName) => {
      
      if(user!=null && user.workingTime!=null){
          switch(elementName){
              case "length":
                 user.workingTime.length = e.floatValue;                  
              break;        
              case "lengthPerMonth":
                 user.workingTime.lengthPerMonth = e.floatValue;                  
              break;           
              case "lunchBreak":
                user.workingTime.lunchBreak = e.floatValue;                  
              break; 
              case "holiday":
                user.workingTime.holiday = e.floatValue;                  
              break; 
              
          }
        
      }
  };


   
    const showError = (error,serverMessage) =>{
      if(serverMessage==null){
          toast.error(
            (error.response &&
                error.response.data &&
                error.response.data.message &&
                error.responseMessage) ||
                t('general.message.failed')
          );
        }else{
          toast.error(serverMessage);
        }
    }

    const save = (url,values) => {
       
      try{
        let startText = moment(start).format('HH:mm:ss');
        user.workingTime.start = startText; //moment(start, "HH:mm");        
  

      }catch(error){
        console.log(error);
      }

      RestService.callAnyApi(url,user)
          .then((data) => {                                                 
                      if(data.responseMessage==='OK'){
                          toast.success(t('general.message.saveSucceed'));                                                                      
                      }else{
                          showError(null,data.responseMessage);
                      }
                  
                 
          })
          .catch((error) => {               
            showError(error,null);
          });
    };

    const formik = useFormik({
      enableReinitialize: true,
      initialValues:{
        
      },
      validationSchema: Yup.object({

      }),
      onSubmit: (values) => {           
          save('user/savePersonal',values);         
      }
      
    });



    return (
        <div className={`tab-pane ${props.isActive ? 'active' : ''}`}>          
                      <form onSubmit={formik.handleSubmit}>     
                   

                      <div className="row">                 					

                              <div className="col-6 col-sm-6 col-lg-6">
                              
                                <label>{t('user.label.start')}</label>  
                                <div className="form-group">                                                                                                                
                                        <DatePicker
                                            className='form-control'                                       
                                            selected={start}
                                            onChange={(value) => setStart(new Date(value).getTime())}                                           
                                            showTimeSelect
                                            showTimeSelectOnly
                                            timeIntervals={30}
                                            timeCaption="Time"
                                            dateFormat="HH:mm"                                    
                                            locale="sk"                                                  
                                        />                                                   						
                                </div>
                              </div>       
                        </div>      

                        <div className="row">                 					

                                  <div className="col-6 col-sm-6 col-lg-6">
                                    <div className="form-group">
                                        <label>{t('user.label.lenght')}</label>                                                                               
                                        <NumberFormat displayType="input" className="form-control col-2 col-sm-2 col-lg-2"  decimalScale="1" thousandSeparator="." decimalSeparator="," suffix={''} value={user && user.workingTime ? user.workingTime.length : 0} onValueChange={(values)  => {handleChange(values,"length")}} />                                                            						
                                    </div>
                                  </div>       
                        </div>      

                        <div className="row">                 					

                                <div className="col-6 col-sm-6 col-lg-6">
                                    <div className="form-group">
                                        <label>{t('user.label.lenghtPerMonth')}</label>                                                                               
                                        <NumberFormat displayType="input" className="form-control col-2 col-sm-2 col-lg-2"  decimalScale="1" thousandSeparator="." decimalSeparator="," suffix={''} value={user && user.workingTime ? user.workingTime.lengthPerMonth : 0} onValueChange={(values)  => {handleChange(values,"lengthPerMonth")}} />                                                            						
                                    </div>
                                </div>       
                        </div>     

                        <div className="row">                 					

                              <div className="col-6 col-sm-6 col-lg-6">
                                  <div className="form-group">
                                      <label>{t('user.label.lunchBreak')}</label>                                                                               
                                      <NumberFormat displayType="input" className="form-control col-2 col-sm-2 col-lg-2"  decimalScale="1" thousandSeparator="." decimalSeparator="," suffix={''} value={user && user.workingTime ? user.workingTime.lunchBreak : 0} onValueChange={(values)  => {handleChange(values,"lunchBreak")}} />                                                            						
                                  </div>
                              </div>       
                        </div>     

                        <div className="row">                 					

                              <div className="col-6 col-sm-6 col-lg-6">
                                  <div className="form-group">
                                      <label>{t('user.label.holiday')}</label>                                                                               
                                      <NumberFormat displayType="input" className="form-control col-2 col-sm-2 col-lg-2"  decimalScale="1" thousandSeparator="." decimalSeparator="," suffix={''} value={user && user.workingTime ? user.workingTime.holiday : 0} onValueChange={(values)  => {handleChange(values,"holiday")}} />                                                            						
                                  </div>
                              </div>       
                        </div>     





                     


                        <div className="card-footer">
                            <Button className="btn-primary" type="submit">{t('general.button.save')}</Button>     
                            <Button className="btn-default float-right" onClick={hideModal}>{t('general.button.cancel')}</Button>    
                                                    
	            	       			
                  			</div>
                        </form>

        </div>
    );
};

export default WorkingTimeTab;